import { AnyObject } from '@mri/types';

export function unFlattenObject(input: { [key: string]: AnyObject }): AnyObject {
  const result: AnyObject = {};

  for (const key in input) {
    const keys = key.split('.');
    let current = result;

    for (let i = 0; i < keys.length; i++) {
      if (i === keys.length - 1) {
        current[keys[i]] = input[key];
      } else {
        current[keys[i]] = current[keys[i]] || {};
        current = current[keys[i]];
      }
    }
  }

  return result;
}
